/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * ByteNite auth API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1
 * Contact: info@bytenite.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://api.bytenite.com/v1/auth".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AuthAccessTokenRequest
 */
export interface AuthAccessTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthAccessTokenRequest
     */
    apiKey?: string;
}

/**
 * 
 * @export
 * @interface AuthAccessTokenResponse
 */
export interface AuthAccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthAccessTokenResponse
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthAccessTokenResponse
     */
    expiresIn?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthAccessTokenResponse
     */
    scope?: string;
}

/**
 * 
 * @export
 * @interface AuthApiKey
 */
export interface AuthApiKey {
    /**
     * 
     * @type {string}
     * @memberof AuthApiKey
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthApiKey
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof AuthApiKey
     */
    issuedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AuthApiKey
     */
    expiresAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AuthApiKey
     */
    userId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthApiKey
     */
    revoked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthApiKey
     */
    fingerprint?: string;
}

/**
 * 
 * @export
 * @interface AuthApiKeyRequest
 */
export interface AuthApiKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiKeyRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthApiKeyRequest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthApiKeyRequest
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthApiKeyRequest
     */
    duration?: string;
}

/**
 * 
 * @export
 * @interface AuthApiKeyResponse
 */
export interface AuthApiKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthApiKeyResponse
     */
    token?: string;
    /**
     * 
     * @type {AuthApiKey}
     * @memberof AuthApiKeyResponse
     */
    apiKey?: AuthApiKey;
}

/**
 * 
 * @export
 * @interface AuthApiKeysResponse
 */
export interface AuthApiKeysResponse {
    /**
     * 
     * @type {Array<AuthApiKey>}
     * @memberof AuthApiKeysResponse
     */
    apiKeys?: Array<AuthApiKey>;
}

/**
 * 
 * @export
 * @interface AuthAuthenticationResponse
 */
export interface AuthAuthenticationResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthAuthenticationResponse
     */
    redirectTo?: string;
}

/**
 * 
 * @export
 * @interface AuthConnectorCredentialsResponse
 */
export interface AuthConnectorCredentialsResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthConnectorCredentialsResponse
     */
    accesToken?: string;
}

/**
 * 
 * @export
 * @interface AuthListSecretsResponse
 */
export interface AuthListSecretsResponse {
    /**
     * 
     * @type {Array<DataSourceSecret>}
     * @memberof AuthListSecretsResponse
     */
    secrets?: Array<DataSourceSecret>;
}

/**
 * 
 * @export
 * @interface AuthLoginChallengeResponse
 */
export interface AuthLoginChallengeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AuthLoginChallengeResponse
     */
    skip?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginChallengeResponse
     */
    redirectTo?: string;
}

/**
 * 
 * @export
 * @interface AuthSaveSecretRequest
 */
export interface AuthSaveSecretRequest {
    /**
     * 
     * @type {DataSourceSecret}
     * @memberof AuthSaveSecretRequest
     */
    secret: DataSourceSecret;
    /**
     * 
     * @type {string}
     * @memberof AuthSaveSecretRequest
     */
    secretKey: string;
}

/**
 * 
 * @export
 * @interface AuthServerInfoResponse
 */
export interface AuthServerInfoResponse {
    /**
     * 
     * @type {CommonVersion}
     * @memberof AuthServerInfoResponse
     */
    version?: CommonVersion;
}

/**
 * 
 * @export
 * @interface AuthSetConnectorTokenRequest
 */
export interface AuthSetConnectorTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthSetConnectorTokenRequest
     */
    connectorName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthSetConnectorTokenRequest
     */
    accessToken?: string;
    /**
     * 
     * @type {Date}
     * @memberof AuthSetConnectorTokenRequest
     */
    expiresAt?: Date;
}

/**
 * 
 * @export
 * @interface AuthSetUserInfoRequest
 */
export interface AuthSetUserInfoRequest {
    /**
     * 
     * @type {AuthUserInfoProperty}
     * @memberof AuthSetUserInfoRequest
     */
    property?: AuthUserInfoProperty;
    /**
     * 
     * @type {any}
     * @memberof AuthSetUserInfoRequest
     */
    value?: any;
}

/**
 * 
 * @export
 * @interface AuthSetUserProfileRequest
 */
export interface AuthSetUserProfileRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AuthSetUserProfileRequest
     */
    addSettings?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthSetUserProfileRequest
     */
    removeSettings?: Array<string>;
}

/**
 * 
 * @export
 * @interface AuthSignInRequest
 */
export interface AuthSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthSignInRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthSignInRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthSignInRequest
     */
    lastName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthSignInRequest
     */
    isNewUser?: boolean;
}

/**
 * 
 * @export
 * @interface AuthSignInResponse
 */
export interface AuthSignInResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AuthSignInResponse
     */
    ok?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AuthSignInResponse
     */
    sentAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AuthSignInResponse
     */
    expireAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AuthSignInResponse
     */
    nonce?: string;
}

/**
 * 
 * @export
 * @interface AuthTokenRequest
 */
export interface AuthTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    accessCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenRequest
     */
    loginChallenge?: string;
}

/**
 * 
 * @export
 * @interface AuthUser
 */
export interface AuthUser {
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof AuthUser
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AuthUser
     */
    lastLogin?: Date;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    photoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    providerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthUser
     */
    emailVerified?: boolean;
    /**
     * 
     * @type {any}
     * @memberof AuthUser
     */
    customClaims?: any;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    role?: string;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum AuthUserInfoProperty {
    INFOEMPTY = <any>'USER_INFO_EMPTY',
    DISPLAYNAME = <any>'USER_DISPLAY_NAME'
}

/**
 * 
 * @export
 * @interface AuthUserInfoResponse
 */
export interface AuthUserInfoResponse {
    /**
     * 
     * @type {AuthUser}
     * @memberof AuthUserInfoResponse
     */
    user?: AuthUser;
}

/**
 * 
 * @export
 * @interface AuthUserProfile
 */
export interface AuthUserProfile {
    /**
     * 
     * @type {string}
     * @memberof AuthUserProfile
     */
    id?: string;
    /**
     * 
     * @type {CommonRole}
     * @memberof AuthUserProfile
     */
    role?: CommonRole;
    /**
     * 
     * @type {Date}
     * @memberof AuthUserProfile
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AuthUserProfile
     */
    lastLogin?: Date;
    /**
     * 
     * @type {any}
     * @memberof AuthUserProfile
     */
    settings?: any;
    /**
     * 
     * @type {boolean}
     * @memberof AuthUserProfile
     */
    mfaEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthUserProfile
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserProfile
     */
    email?: string;
}

/**
 * 
 * @export
 * @interface CommonEmptyMessage
 */
export interface CommonEmptyMessage {
}

/**
 * 
 * @export
 * @interface CommonError
 */
export interface CommonError {
    /**
     * 
     * @type {number}
     * @memberof CommonError
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof CommonError
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof CommonError
     */
    description?: string;
}

/**
 * 
 * @export
 * @interface CommonGenericResponse
 */
export interface CommonGenericResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommonGenericResponse
     */
    ok?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommonGenericResponse
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommonGenericResponse
     */
    message?: string;
    /**
     * 
     * @type {CommonError}
     * @memberof CommonGenericResponse
     */
    error?: CommonError;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum CommonRole {
    NONE = <any>'ROLE_NONE',
    USER = <any>'ROLE_USER',
    ADMIN = <any>'ROLE_ADMIN'
}

/**
 * 
 * @export
 * @interface CommonVersion
 */
export interface CommonVersion {
    /**
     * 
     * @type {number}
     * @memberof CommonVersion
     */
    major?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonVersion
     */
    minor?: number;
    /**
     * 
     * @type {string}
     * @memberof CommonVersion
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface DataSourceSecret
 */
export interface DataSourceSecret {
    /**
     * 
     * @type {string}
     * @memberof DataSourceSecret
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceSecret
     */
    secretType: string;
    /**
     * 
     * @type {Date}
     * @memberof DataSourceSecret
     */
    expiresAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DataSourceSecret
     */
    accessKey: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DataSourceSecret
     */
    params?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof DataSourceSecret
     */
    name: string;
}

/**
 * 'Any' contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }   Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...   Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := anypb.New(foo)      if err != nil {        ...      }      ...      foo := &pb.Foo{}      if err := any.UnmarshalTo(foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use 'type.googleapis.com/full.type.name' as the type URL and the unpack methods only use the fully qualified type name after the last '/' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".   JSON ==== The JSON representation of an 'Any' value uses the regular representation of the deserialized, embedded message, with an additional field '@type' which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field 'value' which holds the custom JSON in addition to the '@type' field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    [key: string]: any | any;

    /**
     * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL's path must represent the fully qualified name of the type (as in 'path/google.protobuf.Duration'). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme 'http', 'https', or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, 'https' is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than 'http', 'https' (or the empty scheme) might be used with implementation specific semantics.
     * @type {string}
     * @memberof ProtobufAny
     */
    type?: string;
}

/**
 * 'NullValue' is a singleton enumeration to represent the null value for the 'Value' type union.   The JSON representation for 'NullValue' is JSON 'null'.   - NULL_VALUE: Null value.
 * @export
 * @enum {string}
 */
export enum ProtobufNullValue {
    NULLVALUE = <any>'NULL_VALUE'
}

/**
 * 
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
    /**
     * 
     * @type {number}
     * @memberof RpcStatus
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof RpcStatus
     */
    message?: string;
    /**
     * 
     * @type {Array<ProtobufAny>}
     * @memberof RpcStatus
     */
    details?: Array<ProtobufAny>;
}


/**
 * ApiKeysApi - fetch parameter creator
 * @export
 */
export const ApiKeysApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all issued api keys for user
         * @summary Generic information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApiKeys(options: any = {}): FetchArgs {
            const localVarPath = `/api_keys`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke an API key
         * @summary Revoke an API key
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRevokeApiKey(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling authRevokeApiKey.');
            }
            const localVarPath = `/api_keys/{id}/revoke`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiKeysApi - functional programming interface
 * @export
 */
export const ApiKeysApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Get all issued api keys for user
         * @summary Generic information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApiKeys(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthApiKeysResponse> {
            const localVarFetchArgs = ApiKeysApiFetchParamCreator(configuration).authApiKeys(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Revoke an API key
         * @summary Revoke an API key
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRevokeApiKey(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
            const localVarFetchArgs = ApiKeysApiFetchParamCreator(configuration).authRevokeApiKey(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ApiKeysApi - factory interface
 * @export
 */
export const ApiKeysApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get all issued api keys for user
         * @summary Generic information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApiKeys(options?: any) {
            return ApiKeysApiFp(configuration).authApiKeys(options)(fetch, basePath);
        },
        /**
         * Revoke an API key
         * @summary Revoke an API key
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRevokeApiKey(id: string, options?: any) {
            return ApiKeysApiFp(configuration).authRevokeApiKey(id, options)(fetch, basePath);
        },
    };
};

/**
 * ApiKeysApi - object-oriented interface
 * @export
 * @class ApiKeysApi
 * @extends {BaseAPI}
 */
export class ApiKeysApi extends BaseAPI {
    /**
     * Get all issued api keys for user
     * @summary Generic information about user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public authApiKeys(options?: any) {
        return ApiKeysApiFp(this.configuration).authApiKeys(options)(this.fetch, this.basePath);
    }

    /**
     * Revoke an API key
     * @summary Revoke an API key
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public authRevokeApiKey(id: string, options?: any) {
        return ApiKeysApiFp(this.configuration).authRevokeApiKey(id, options)(this.fetch, this.basePath);
    }

}

/**
 * AuthApi - fetch parameter creator
 * @export
 */
export const AuthApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validate the OTP code to authenticate the user
         * @summary Exchange OTP for token
         * @param {AuthTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAuthenticate(body: AuthTokenRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authAuthenticate.');
            }
            const localVarPath = `/authenticate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthTokenRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get temporary credentials for an external connector
         * @summary Get credentials for an external connector
         * @param {string} connectorName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetConnectorCredentials(connectorName: string, options: any = {}): FetchArgs {
            // verify required parameter 'connectorName' is not null or undefined
            if (connectorName === null || connectorName === undefined) {
                throw new RequiredError('connectorName', 'Required parameter connectorName was null or undefined when calling authGetConnectorCredentials.');
            }
            const localVarPath = `/connector_credentials/{connectorName}`
                .replace(`{${"connectorName"}}`, encodeURIComponent(String(connectorName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange an API key for an oAuth2 access token
         * @summary Exchange API key for access token
         * @param {AuthAccessTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestAccessToken(body: AuthAccessTokenRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authRequestAccessToken.');
            }
            const localVarPath = `/access_token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthAccessTokenRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange the OTP code for an API key that could be used for authentication
         * @summary Exchange OTP for API key
         * @param {AuthApiKeyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestApiKey(body: AuthApiKeyRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authRequestApiKey.');
            }
            const localVarPath = `/api_key`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthApiKeyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Require an email with an OTP code that could be used to obtain an ID token
         * @summary Send OTP to email address
         * @param {AuthSignInRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestSignInCode(body: AuthSignInRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authRequestSignInCode.');
            }
            const localVarPath = `/signin`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthSignInRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Log out current user and invalidates token
         * @summary User signout
         * @param {CommonEmptyMessage} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignOut(body: CommonEmptyMessage, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authSignOut.');
            }
            const localVarPath = `/signout`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CommonEmptyMessage" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if the user is already logged in, if the user can skip login a redirect url is returned
         * @summary Check if the user is already logged in
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSkipLogin(loginChallenge?: string, options: any = {}): FetchArgs {
            const localVarPath = `/skip`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (loginChallenge !== undefined) {
                localVarQueryParameter['loginChallenge'] = loginChallenge;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Validate the OTP code to authenticate the user
         * @summary Exchange OTP for token
         * @param {AuthTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAuthenticate(body: AuthTokenRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthAuthenticationResponse> {
            const localVarFetchArgs = AuthApiFetchParamCreator(configuration).authAuthenticate(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get temporary credentials for an external connector
         * @summary Get credentials for an external connector
         * @param {string} connectorName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetConnectorCredentials(connectorName: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthConnectorCredentialsResponse> {
            const localVarFetchArgs = AuthApiFetchParamCreator(configuration).authGetConnectorCredentials(connectorName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Exchange an API key for an oAuth2 access token
         * @summary Exchange API key for access token
         * @param {AuthAccessTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestAccessToken(body: AuthAccessTokenRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthAccessTokenResponse> {
            const localVarFetchArgs = AuthApiFetchParamCreator(configuration).authRequestAccessToken(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Exchange the OTP code for an API key that could be used for authentication
         * @summary Exchange OTP for API key
         * @param {AuthApiKeyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestApiKey(body: AuthApiKeyRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthApiKeyResponse> {
            const localVarFetchArgs = AuthApiFetchParamCreator(configuration).authRequestApiKey(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Require an email with an OTP code that could be used to obtain an ID token
         * @summary Send OTP to email address
         * @param {AuthSignInRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestSignInCode(body: AuthSignInRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthSignInResponse> {
            const localVarFetchArgs = AuthApiFetchParamCreator(configuration).authRequestSignInCode(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Log out current user and invalidates token
         * @summary User signout
         * @param {CommonEmptyMessage} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignOut(body: CommonEmptyMessage, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
            const localVarFetchArgs = AuthApiFetchParamCreator(configuration).authSignOut(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check if the user is already logged in, if the user can skip login a redirect url is returned
         * @summary Check if the user is already logged in
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSkipLogin(loginChallenge?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthLoginChallengeResponse> {
            const localVarFetchArgs = AuthApiFetchParamCreator(configuration).authSkipLogin(loginChallenge, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Validate the OTP code to authenticate the user
         * @summary Exchange OTP for token
         * @param {AuthTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAuthenticate(body: AuthTokenRequest, options?: any) {
            return AuthApiFp(configuration).authAuthenticate(body, options)(fetch, basePath);
        },
        /**
         * Get temporary credentials for an external connector
         * @summary Get credentials for an external connector
         * @param {string} connectorName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetConnectorCredentials(connectorName: string, options?: any) {
            return AuthApiFp(configuration).authGetConnectorCredentials(connectorName, options)(fetch, basePath);
        },
        /**
         * Exchange an API key for an oAuth2 access token
         * @summary Exchange API key for access token
         * @param {AuthAccessTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestAccessToken(body: AuthAccessTokenRequest, options?: any) {
            return AuthApiFp(configuration).authRequestAccessToken(body, options)(fetch, basePath);
        },
        /**
         * Exchange the OTP code for an API key that could be used for authentication
         * @summary Exchange OTP for API key
         * @param {AuthApiKeyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestApiKey(body: AuthApiKeyRequest, options?: any) {
            return AuthApiFp(configuration).authRequestApiKey(body, options)(fetch, basePath);
        },
        /**
         * Require an email with an OTP code that could be used to obtain an ID token
         * @summary Send OTP to email address
         * @param {AuthSignInRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestSignInCode(body: AuthSignInRequest, options?: any) {
            return AuthApiFp(configuration).authRequestSignInCode(body, options)(fetch, basePath);
        },
        /**
         * Log out current user and invalidates token
         * @summary User signout
         * @param {CommonEmptyMessage} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignOut(body: CommonEmptyMessage, options?: any) {
            return AuthApiFp(configuration).authSignOut(body, options)(fetch, basePath);
        },
        /**
         * Check if the user is already logged in, if the user can skip login a redirect url is returned
         * @summary Check if the user is already logged in
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSkipLogin(loginChallenge?: string, options?: any) {
            return AuthApiFp(configuration).authSkipLogin(loginChallenge, options)(fetch, basePath);
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Validate the OTP code to authenticate the user
     * @summary Exchange OTP for token
     * @param {AuthTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authAuthenticate(body: AuthTokenRequest, options?: any) {
        return AuthApiFp(this.configuration).authAuthenticate(body, options)(this.fetch, this.basePath);
    }

    /**
     * Get temporary credentials for an external connector
     * @summary Get credentials for an external connector
     * @param {string} connectorName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authGetConnectorCredentials(connectorName: string, options?: any) {
        return AuthApiFp(this.configuration).authGetConnectorCredentials(connectorName, options)(this.fetch, this.basePath);
    }

    /**
     * Exchange an API key for an oAuth2 access token
     * @summary Exchange API key for access token
     * @param {AuthAccessTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authRequestAccessToken(body: AuthAccessTokenRequest, options?: any) {
        return AuthApiFp(this.configuration).authRequestAccessToken(body, options)(this.fetch, this.basePath);
    }

    /**
     * Exchange the OTP code for an API key that could be used for authentication
     * @summary Exchange OTP for API key
     * @param {AuthApiKeyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authRequestApiKey(body: AuthApiKeyRequest, options?: any) {
        return AuthApiFp(this.configuration).authRequestApiKey(body, options)(this.fetch, this.basePath);
    }

    /**
     * Require an email with an OTP code that could be used to obtain an ID token
     * @summary Send OTP to email address
     * @param {AuthSignInRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authRequestSignInCode(body: AuthSignInRequest, options?: any) {
        return AuthApiFp(this.configuration).authRequestSignInCode(body, options)(this.fetch, this.basePath);
    }

    /**
     * Log out current user and invalidates token
     * @summary User signout
     * @param {CommonEmptyMessage} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authSignOut(body: CommonEmptyMessage, options?: any) {
        return AuthApiFp(this.configuration).authSignOut(body, options)(this.fetch, this.basePath);
    }

    /**
     * Check if the user is already logged in, if the user can skip login a redirect url is returned
     * @summary Check if the user is already logged in
     * @param {string} [loginChallenge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authSkipLogin(loginChallenge?: string, options?: any) {
        return AuthApiFp(this.configuration).authSkipLogin(loginChallenge, options)(this.fetch, this.basePath);
    }

}

/**
 * ConnectorsApi - fetch parameter creator
 * @export
 */
export const ConnectorsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove a stored external connector token
         * @summary Remove a stored external connector token
         * @param {string} connectorName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRemoveConnectorToken(connectorName: string, options: any = {}): FetchArgs {
            // verify required parameter 'connectorName' is not null or undefined
            if (connectorName === null || connectorName === undefined) {
                throw new RequiredError('connectorName', 'Required parameter connectorName was null or undefined when calling authRemoveConnectorToken.');
            }
            const localVarPath = `/connectors/token/{connectorName}`
                .replace(`{${"connectorName"}}`, encodeURIComponent(String(connectorName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set external connector token for api usage
         * @summary Set external connector token
         * @param {AuthSetConnectorTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetConnectorToken(body: AuthSetConnectorTokenRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authSetConnectorToken.');
            }
            const localVarPath = `/connectors/token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthSetConnectorTokenRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectorsApi - functional programming interface
 * @export
 */
export const ConnectorsApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Remove a stored external connector token
         * @summary Remove a stored external connector token
         * @param {string} connectorName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRemoveConnectorToken(connectorName: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
            const localVarFetchArgs = ConnectorsApiFetchParamCreator(configuration).authRemoveConnectorToken(connectorName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Set external connector token for api usage
         * @summary Set external connector token
         * @param {AuthSetConnectorTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetConnectorToken(body: AuthSetConnectorTokenRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
            const localVarFetchArgs = ConnectorsApiFetchParamCreator(configuration).authSetConnectorToken(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ConnectorsApi - factory interface
 * @export
 */
export const ConnectorsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Remove a stored external connector token
         * @summary Remove a stored external connector token
         * @param {string} connectorName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRemoveConnectorToken(connectorName: string, options?: any) {
            return ConnectorsApiFp(configuration).authRemoveConnectorToken(connectorName, options)(fetch, basePath);
        },
        /**
         * Set external connector token for api usage
         * @summary Set external connector token
         * @param {AuthSetConnectorTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetConnectorToken(body: AuthSetConnectorTokenRequest, options?: any) {
            return ConnectorsApiFp(configuration).authSetConnectorToken(body, options)(fetch, basePath);
        },
    };
};

/**
 * ConnectorsApi - object-oriented interface
 * @export
 * @class ConnectorsApi
 * @extends {BaseAPI}
 */
export class ConnectorsApi extends BaseAPI {
    /**
     * Remove a stored external connector token
     * @summary Remove a stored external connector token
     * @param {string} connectorName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public authRemoveConnectorToken(connectorName: string, options?: any) {
        return ConnectorsApiFp(this.configuration).authRemoveConnectorToken(connectorName, options)(this.fetch, this.basePath);
    }

    /**
     * Set external connector token for api usage
     * @summary Set external connector token
     * @param {AuthSetConnectorTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public authSetConnectorToken(body: AuthSetConnectorTokenRequest, options?: any) {
        return ConnectorsApiFp(this.configuration).authSetConnectorToken(body, options)(this.fetch, this.basePath);
    }

}

/**
 * InfoApi - fetch parameter creator
 * @export
 */
export const InfoApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Server software version
         * @summary Retrieve information about server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authInfo(options: any = {}): FetchArgs {
            const localVarPath = `/info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoApi - functional programming interface
 * @export
 */
export const InfoApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Server software version
         * @summary Retrieve information about server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthServerInfoResponse> {
            const localVarFetchArgs = InfoApiFetchParamCreator(configuration).authInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InfoApi - factory interface
 * @export
 */
export const InfoApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Server software version
         * @summary Retrieve information about server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authInfo(options?: any) {
            return InfoApiFp(configuration).authInfo(options)(fetch, basePath);
        },
    };
};

/**
 * InfoApi - object-oriented interface
 * @export
 * @class InfoApi
 * @extends {BaseAPI}
 */
export class InfoApi extends BaseAPI {
    /**
     * Server software version
     * @summary Retrieve information about server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoApi
     */
    public authInfo(options?: any) {
        return InfoApiFp(this.configuration).authInfo(options)(this.fetch, this.basePath);
    }

}

/**
 * ProfileApi - fetch parameter creator
 * @export
 */
export const ProfileApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get user profile info
         * @summary Detailed information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetUserProfile(options: any = {}): FetchArgs {
            const localVarPath = `/profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user profile info
         * @summary Detailed information about user
         * @param {AuthSetUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetUserProfile(body: AuthSetUserProfileRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authSetUserProfile.');
            }
            const localVarPath = `/profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthSetUserProfileRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Get user profile info
         * @summary Detailed information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetUserProfile(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthUserProfile> {
            const localVarFetchArgs = ProfileApiFetchParamCreator(configuration).authGetUserProfile(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get user profile info
         * @summary Detailed information about user
         * @param {AuthSetUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetUserProfile(body: AuthSetUserProfileRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthUserProfile> {
            const localVarFetchArgs = ProfileApiFetchParamCreator(configuration).authSetUserProfile(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get user profile info
         * @summary Detailed information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetUserProfile(options?: any) {
            return ProfileApiFp(configuration).authGetUserProfile(options)(fetch, basePath);
        },
        /**
         * Get user profile info
         * @summary Detailed information about user
         * @param {AuthSetUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetUserProfile(body: AuthSetUserProfileRequest, options?: any) {
            return ProfileApiFp(configuration).authSetUserProfile(body, options)(fetch, basePath);
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * Get user profile info
     * @summary Detailed information about user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public authGetUserProfile(options?: any) {
        return ProfileApiFp(this.configuration).authGetUserProfile(options)(this.fetch, this.basePath);
    }

    /**
     * Get user profile info
     * @summary Detailed information about user
     * @param {AuthSetUserProfileRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public authSetUserProfile(body: AuthSetUserProfileRequest, options?: any) {
        return ProfileApiFp(this.configuration).authSetUserProfile(body, options)(this.fetch, this.basePath);
    }

}

/**
 * SecretsApi - fetch parameter creator
 * @export
 */
export const SecretsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove a secret
         * @summary Remove a secret
         * @param {string} secretType 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authDeleteSecret(secretType: string, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'secretType' is not null or undefined
            if (secretType === null || secretType === undefined) {
                throw new RequiredError('secretType', 'Required parameter secretType was null or undefined when calling authDeleteSecret.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling authDeleteSecret.');
            }
            const localVarPath = `/secrets/{secretType}/{id}`
                .replace(`{${"secretType"}}`, encodeURIComponent(String(secretType)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List available secrets
         * @summary List available secrets
         * @param {string} [secretType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authListSecrets(secretType?: string, options: any = {}): FetchArgs {
            const localVarPath = `/secrets`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (secretType !== undefined) {
                localVarQueryParameter['secretType'] = secretType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save a secret for data sources/destinations usage
         * @summary Create or update a secret
         * @param {AuthSaveSecretRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSaveSecret(body: AuthSaveSecretRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authSaveSecret.');
            }
            const localVarPath = `/secrets`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthSaveSecretRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecretsApi - functional programming interface
 * @export
 */
export const SecretsApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Remove a secret
         * @summary Remove a secret
         * @param {string} secretType 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authDeleteSecret(secretType: string, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
            const localVarFetchArgs = SecretsApiFetchParamCreator(configuration).authDeleteSecret(secretType, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * List available secrets
         * @summary List available secrets
         * @param {string} [secretType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authListSecrets(secretType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthListSecretsResponse> {
            const localVarFetchArgs = SecretsApiFetchParamCreator(configuration).authListSecrets(secretType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Save a secret for data sources/destinations usage
         * @summary Create or update a secret
         * @param {AuthSaveSecretRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSaveSecret(body: AuthSaveSecretRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
            const localVarFetchArgs = SecretsApiFetchParamCreator(configuration).authSaveSecret(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SecretsApi - factory interface
 * @export
 */
export const SecretsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Remove a secret
         * @summary Remove a secret
         * @param {string} secretType 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authDeleteSecret(secretType: string, id: string, options?: any) {
            return SecretsApiFp(configuration).authDeleteSecret(secretType, id, options)(fetch, basePath);
        },
        /**
         * List available secrets
         * @summary List available secrets
         * @param {string} [secretType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authListSecrets(secretType?: string, options?: any) {
            return SecretsApiFp(configuration).authListSecrets(secretType, options)(fetch, basePath);
        },
        /**
         * Save a secret for data sources/destinations usage
         * @summary Create or update a secret
         * @param {AuthSaveSecretRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSaveSecret(body: AuthSaveSecretRequest, options?: any) {
            return SecretsApiFp(configuration).authSaveSecret(body, options)(fetch, basePath);
        },
    };
};

/**
 * SecretsApi - object-oriented interface
 * @export
 * @class SecretsApi
 * @extends {BaseAPI}
 */
export class SecretsApi extends BaseAPI {
    /**
     * Remove a secret
     * @summary Remove a secret
     * @param {string} secretType 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretsApi
     */
    public authDeleteSecret(secretType: string, id: string, options?: any) {
        return SecretsApiFp(this.configuration).authDeleteSecret(secretType, id, options)(this.fetch, this.basePath);
    }

    /**
     * List available secrets
     * @summary List available secrets
     * @param {string} [secretType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretsApi
     */
    public authListSecrets(secretType?: string, options?: any) {
        return SecretsApiFp(this.configuration).authListSecrets(secretType, options)(this.fetch, this.basePath);
    }

    /**
     * Save a secret for data sources/destinations usage
     * @summary Create or update a secret
     * @param {AuthSaveSecretRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretsApi
     */
    public authSaveSecret(body: AuthSaveSecretRequest, options?: any) {
        return SecretsApiFp(this.configuration).authSaveSecret(body, options)(this.fetch, this.basePath);
    }

}

/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set editable user info
         * @summary Set user info
         * @param {AuthSetUserInfoRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetUserInfo(body: AuthSetUserInfoRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authSetUserInfo.');
            }
            const localVarPath = `/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuthSetUserInfoRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get id, email, name, image and activation status
         * @summary Generic information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserInfo(options: any = {}): FetchArgs {
            const localVarPath = `/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
    return {
        /**
         * Set editable user info
         * @summary Set user info
         * @param {AuthSetUserInfoRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetUserInfo(body: AuthSetUserInfoRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthUserInfoResponse> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).authSetUserInfo(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get id, email, name, image and activation status
         * @summary Generic information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthUserInfoResponse> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).authUserInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Set editable user info
         * @summary Set user info
         * @param {AuthSetUserInfoRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetUserInfo(body: AuthSetUserInfoRequest, options?: any) {
            return UserApiFp(configuration).authSetUserInfo(body, options)(fetch, basePath);
        },
        /**
         * Get id, email, name, image and activation status
         * @summary Generic information about user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserInfo(options?: any) {
            return UserApiFp(configuration).authUserInfo(options)(fetch, basePath);
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Set editable user info
     * @summary Set user info
     * @param {AuthSetUserInfoRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public authSetUserInfo(body: AuthSetUserInfoRequest, options?: any) {
        return UserApiFp(this.configuration).authSetUserInfo(body, options)(this.fetch, this.basePath);
    }

    /**
     * Get id, email, name, image and activation status
     * @summary Generic information about user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public authUserInfo(options?: any) {
        return UserApiFp(this.configuration).authUserInfo(options)(this.fetch, this.basePath);
    }

}

